import { httpClient } from "@/core/api/httpClient";

export default {
  sendResetEmail: async (email) => {
    return await httpClient.post("/forgot-password", {
      email,
    });
  },
  setPassword: async (password, token) => {
    return await httpClient.post("/set-password", {
      password,
      token,
    });
  },
  changeTempPassword: async (password) => {
    return await httpClient.post("/change-temp-password", {
      password,
    });
  },
  login: async (username, password) => {
    return await httpClient.post("/login", {
      password,
      username,
    });
  },
  logout: async () => {
    return await httpClient.get("/logout");
  },
  verifyTwoFactorAuth: async (payload) => {
    return httpClient.post("/two-factor-auth/verify", payload);
  },
  resendTwoFactorAuthCode: async () => {
    return httpClient.post("/two-factor-auth/resend");
  },
  checkStatusTwoFactorAuth: async () => {
    return httpClient.post("/two-factor-auth/status");
  },
};
